import { captureException as sentryCapture, setExtra } from '@sentry/browser';

export const captureException = (error: any, data: any): void => {
  void (async () => {
    if (error) {
      if (Object?.keys(error)?.length === 0) return;
      let exception = error;
      if (typeof exception !== 'string' && !(error instanceof Error)) {
        exception = JSON.stringify(exception);
      }
      if (data.extra) setExtra('extra', data.extra);
      sentryCapture(exception, data);
    }
  })();
};

export default captureException;
